(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["portl-header-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const opener=event.target.closest('[data-portl-search]');
 const close=event.target.closest('[data-portl-search-close]');
 const dialog=document.getElementById('portl-search-dialog');
 if(!dialog)return;
 if(opener&&typeof dialog.showModal==='function'){
  event.preventDefault();
  dialog.showModal();
  dialog.querySelector('input[name="q"]').focus();
 }
 if(close)dialog.close();
 if(event.target===dialog){
  const rect=dialog.getBoundingClientRect();
  if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
 }
});
  } catch(e) { console.error(e); }
})();

})();
